import { render, staticRenderFns } from "./cours.vue?vue&type=template&id=520130ac&"
import script from "./cours.vue?vue&type=script&lang=js&"
export * from "./cours.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports